import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    //Table,
    Spinner
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as productAction from "../../../store/Zm9sbG93dX/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
//import moment from "moment"
import api from "helpers/Api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ReactDOM from 'react-dom'
import FollowupReportTabComponent from "./FollowupReportTabComponent"

const FollowupReport = (props) => {
    const { searchBtnStyle, dispatch } = props

    const title = "Followup Report"

    //Fetching API
    useEffect(() => {

          dispatch(productAction.loadProductStatus())
        dispatch(productAction.loadRecordsMetaData())
    }, [])
    //Date format
    const sessionUpdate = useSelector((specificstate) => specificstate.session)
    const { user = [] } = sessionUpdate

    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []
    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
    //date format
    const update = useSelector((specificstate) => specificstate.followupReport)
   
    //product_data
    const { product_data = [], recordsMetaData = {} } = update

    const [employee, setEmployee] = useState([])



    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value
    const employees = !isEmpty(employee) && employee.map((m) => m.value)
    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [btnLoader, setBtnLoader] = useState(false)



    const handleFilter = (e) => {
        e.preventDefault()

        var searchEmployee = !isEmpty(employee) && employee ? employees : ""


        var searchvalue = {}

        if (searchEmployee) {
            searchvalue.crmId = searchEmployee
        }


         dispatch(productAction.loadProductStatus(searchvalue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)


    }

    //reset

    const resetForm = () => {
        setEmployee([])
        setSearchInput("")

          dispatch(productAction.loadProductStatus())
    }
    //
    const productStatusTable = !isEmpty(product_data) && product_data.length > 0 ?
        product_data.map((data, index) => {

            return {
                _id: index,
                sNo: index + 1,
                crmId: data.crmId,
                empCode: data.empCode,
                crmName: data.crmName,
                avg_30_Days: data.avg_30_Days ? data.avg_30_Days : "--",
                avg_60_Days: data.avg_60_Days ? data.avg_60_Days : "--",
                totalLeadCount: data.totalLeadCount ? data.totalLeadCount : "--",
                leadWithoutFollowup: data.leadWithoutFollowup ? data.leadWithoutFollowup : "--",
                totalFutureFollowup: data.totalFutureFollowup ? data.totalFutureFollowup : "--",
                totalAgingFollowup: data.totalAgingFollowup ? data.totalAgingFollowup : "--",
                highestAging: data.highestAging ? data.highestAging : "--",
                onTime_30_days: data.onTime_30_days ? data.onTime_30_days : "--",
                onTime_60_days: data.onTime_60_days ? data.onTime_60_days : "--"

            }


        }) : []



    const handleClickTab = (tabData) => {
        const mode = tabData.menuMode
        const statusName = tabData.crmName
        const statusDetails = {
              crmId:tabData.crmId,
              menuMode:tabData.menuMode
        }
      

        api
            .post(`/crm_deliverable_followup_report_details`, statusDetails)
            .then((response) => {
                const statusData = !isEmpty(response.data.data) ? response.data.data : []
                setTimeout(() => {
                    // Use the current value of statusData, which should be updated due to the useEffect

                    const newTab = window.open("", "_blank", "width=600,height=400")
                       const format = "dd/mm/yyyy"
                    if (newTab) {
                        const container = newTab.document.createElement("div")
                        newTab.document.body.appendChild(container)
                        ReactDOM.render(
                            <FollowupReportTabComponent
                                data={statusData} // Use statusData directly here
                                dispatch={dispatch}
                                statusPayload={statusDetails}
                                name={statusName}
                                dateFormat={dateFormat || format}
                                mode={mode}
                            />,
                            container
                        )
                        newTab.document.title = "PRODUCT-STATUS-REPORT"
                    }
                }, 2000)
            })
            .catch((error) => {
                Promise.reject(error)
                const newTab = window.open("", "_blank", "width=600,height=400")
                if (newTab) {
                    const container = newTab.document.createElement("div")
                    newTab.document.body.appendChild(container)
                    ReactDOM.render(
                        <FollowupReportTabComponent
                            data={[]} // Use statusData directly here
                            dispatch={dispatch}
                            statusPayload={statusDetails}
                            name={statusName}
                            dateFormat={dateFormat}
                        />,
                        container
                    )
                    newTab.document.title = "PRODUCT-STATUS-REPORT"
                }
            })
    }


    const columns = [

        {
            dataField: "crmName",
            text: "CRM Name",
            csvExport: false,
            headerStyle: {
                minWidth: "170px",
                position: "sticky",
                left: 0,
                backgroundColor: "#F8F8FB",
                zIndex: 0,
            },
            formatter: (cellContent, row) => {

                return (
                    <div
                        style={{ textTransform: 'uppercase', fontWeight: 'bold' }}
                    >
                        {row.crmName && row.empCode ? `${row.empCode} - ${row.crmName}` : "--"}
                    </div>
                )
            },

            style: {
                position: "sticky",
                left: 0,
                backgroundColor: "#F8F8FB",
                zIndex: 0,
            },
         
        },
        {
            dataField: "avg_30_Days",
            text: "Avg Followup Per Day (30 Days)",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            style: {
                fontSize: "14px",
                textAlign: "center", }

        },
        {
            dataField: "avg_60_Days",
            text: "Avg Followup Per Day (60 Days)",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            style: {
                fontSize: "14px",
                textAlign: "center", }
        },
        {
            dataField: "totalLeadCount",
            text: "Total Lead Count",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            style: {
                fontSize: "14px",
                textAlign: "center", }

        },
        {
            dataField: "leadWithoutFollowup",
            text: "Lead Count Without Followup",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            formatter: (cellContent, row) => {
                const tabData = {
                    crmId:row.crmId,
                    statusName:row.crmName,
                    menuMode:2
                }

                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tabData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
                textAlign: "center", 
            },

        },
        {
            dataField: "totalFutureFollowup",
            text: "Total No of Future Followups",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            formatter: (cellContent, row) => {
                const tabData = {
                    crmId:row.crmId,
                    statusName:row.crmName,
                    menuMode:3
                }

                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tabData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
                textAlign: "center", 
            },

        },
        {
            dataField: "totalAgingFollowup",
            text: "Total No of Aging Followups",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            formatter: (cellContent, row) => {
                const tabData = {
                    crmId:row.crmId,
                    statusName:row.crmName,
                    menuMode:4
                }

                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tabData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
                textAlign: "center", 
            },

        },
        {
            dataField: "highestAging",
            text: "Highest Aging",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            formatter: (cellContent, row) => {
                const tabData = {
                    crmId:row.crmId,
                    statusName:row.crmName,
                    menuMode:5
                }

                return (
                    <div
                        style={{ fontWeight: 'bold' }}
                        onClick={() => handleClickTab(tabData)}
                    >
                        {cellContent}
                    </div>
                )
            },
            style: {
                color: "#e40d8c",
                fontSize: "14px",
                textDecoration: "underline",
                textAlign: "center", 
            },

        },
        {
            dataField: "onTime_30_days",
            text: "On Time Followup Completion % (30 Days)",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
         
            style: {fontSize: "14px",
                textAlign: "center", 
            },

        },
        {
            dataField: "onTime_60_days",
            text: "On Time Followup Completion % (60 Days)",
            csvExport: false,
            headerStyle: {
                minWidth: "150px",
                textAlign: "center", // Centers the text in the header
                whiteSpace: "normal", // Enables text wrapping
                wordWrap: "break-word" // Ensures long words break into the next line
            },
            style: {fontSize: "14px",
                textAlign: "center", 
            },
        },
    ]

    const options = {
        sizePerPage: 50,
        totalSize: product_data.length,
        custom: true,
        pageStartIndex: 1,
        firstPageText: "First",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
    }


    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(productAction.loadProductStatus({
            searchFilter: searchInput,

        }))
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }


    const exportToCsv = () => {
        var searchEmployee = employee && employee ? employees : ""


        var searchvalue = {}

        if (searchEmployee) {
            searchvalue.CRMEmpId = searchEmployee
        }


        setDownloadLoading(true)

        api
            .post(`/crm_deliverable_followup_report`, searchvalue)
            .then((response) => {


                const photoExportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {

                        return {
                            _id: index,
                            sNo: index + 1,
                            crmId: data.crmId,
                            empCode: data.empCode,
                            crmName: data.crmName,
                            avg_30_Days: data.avg_30_Days ? data.avg_30_Days : "--",
                            avg_60_Days: data.avg_60_Days ? data.avg_60_Days : "--",
                            totalLeadCount: data.totalLeadCount ? data.totalLeadCount : "--",
                            leadWithoutFollowup: data.leadWithoutFollowup ? data.leadWithoutFollowup : "--",
                            totalFutureFollowup: data.totalFutureFollowup ? data.totalFutureFollowup : "--",
                            totalAgingFollowup: data.totalAgingFollowup ? data.totalAgingFollowup : "--",
                            highestAging: data.highestAging ? data.highestAging : "--",
                            onTime_30_days: data.onTime_30_days ? data.onTime_30_days : "--",
                            onTime_60_days: data.onTime_60_days ? data.onTime_60_days : "--"
                        }
                    })
                    : []
                setTimeout(() => {
                    let headerData = [
                        "CRM Name,Average Followup Per Day (30 Days),Average Followup Per Day (60 Days),Total Lead Count,Lead Count Without Followup,Total No of Future Followups,Total No of Aging Followups,Highest Aging,On Time Followup Completion % (30 Days),On Time Followup Completion % (60 Days)"
                    ]
                  
                    let usersCsv =
                        !isEmpty(photoExportDataTable) &&
                        photoExportDataTable.reduce((acc, user) => {
                            const {
                                crmName,
                                avg_30_Days,
                                avg_60_Days,
                                totalLeadCount,
                                leadWithoutFollowup,
                                totalFutureFollowup,
                                totalAgingFollowup,
                                highestAging,
                                onTime_30_days,
                                onTime_60_days
                            } = user
                            acc.push([
                                crmName,
                                avg_30_Days,
                                avg_60_Days,
                                totalLeadCount,
                                leadWithoutFollowup,
                                totalFutureFollowup,
                                totalAgingFollowup,
                                highestAging,
                                onTime_30_days,
                                onTime_60_days
                            ])

                            return acc
                        }, [])

                    downloadFile({
                        data: [...headerData, ...usersCsv].join("\n"),
                        fileName: "FollowupReport.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 1000)
                return response.data
            })
            .catch((error) => {
                Promise.reject(error)
                setDownloadLoading(false)
            })
    }
    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">CRM Name</Label>
                                            <Select
                                                type="text"
                                                name="employee"
                                                isMulti
                                                value={employee}
                                                onChange={(e) => setEmployee(e)}
                                                options={
                                                    recordsMetaData ? recordsMetaData.employeeOptions : []
                                                }
                                                placeholder="Select CRM Employee"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>


                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md="12" lg="12" xl="12">
                        <Card>
                            <CardBody>

                                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className="btn btn-success mx-2"
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#ffffff" : "",
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </form>
                                    </div>

                                </div>
                                <Row>
                                    <Col md="4" lg="4" sm="12"></Col>
                                    <Col md="8" lg="8" sm="12" style={{ marginBottom: "20px", marginTop: "-41px" }}>
                                        <div
                                            style={{
                                                float: "right",
                                            }}
                                        >
                                            <Button
                                                className="btn btn-primary"
                                                onClick={exportToCsv}
                                                id="download"
                                                style={{
                                                    backgroundColor: "#e40d8c",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    </Col></Row>

                                <Col md="12" lg="12" xl="12" className="mt-3">


                                    <PaginationProvider
                                        pagination={paginationFactory(options)}
                                    >
                                        {
                                            ({
                                                paginationProps,
                                                paginationTableProps
                                            }) => (
                                                <div>
                                                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                                        <Row className="d-flex flex-row  ">

                                                            <Col style={{ overflowX: "auto", width: "100%" }}>
                                                                <BootstrapTable
                                                                    data={productStatusTable}
                                                                    noDataIndication={"No Data Found..."}
                                                                    bordered={true}
                                                                    keyField="_id"
                                                                    columns={columns}
                                                                    {...paginationTableProps}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row
                                                            style={{ marginTop: "5px" }}
                                                            className="align-items-md-center mt-30"
                                                        >
                                                            <Col className="inner-custom-pagination d-flex">
                                                                <div className="d-inline d-flex flex-row">
                                                                    <SizePerPageDropdownStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                    <div
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            marginTop: "8px",
                                                                            marginLeft: "4px",
                                                                        }}
                                                                    >
                                                                        <PaginationTotalStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="text-md-right ms-auto"
                                                                    style={{ zIndex: 0 }}
                                                                >
                                                                    <PaginationListStandalone
                                                                        {...paginationProps}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </div>
                                            )
                                        }
                                    </PaginationProvider>


                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}


        </div>
    )
}
FollowupReport.propTypes = {
    dispatch: PropTypes.func,
    searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,FollowupReport
})
//FollowupReport
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(FollowupReport)
)
